import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { API_URL_CANCEL_PURCHASE } from "../../../constants";
import { RootState } from "../../../models";
import * as Ajax from "../../packages/app/Ajax";
import * as APP_AT from "../../packages/app/state/actionTypes";

export function hideInvalidOrderModal() {
    return {
        type: APP_AT.GENERAL_SHOW_GLOBAL_MODAL,
        payload: { invalidOrder: false },
    };
}

export function hideLockedOrderModal() {
    return {
        type: APP_AT.GENERAL_SHOW_GLOBAL_MODAL,
        payload: { lockedOrder: false },
    };
}

export function cancelPurchaseAndHideLockedOrderModal(): ThunkAction<void, RootState, unknown, AnyAction> {
    return (dispatch) => {
        dispatch({
            type: "CANCEL_PURCHASE",
            payload: Ajax.post({ url: API_URL_CANCEL_PURCHASE }, dispatch)
                .then(() => dispatch(hideLockedOrderModal()))
                .catch(() => dispatch(hideLockedOrderModal())),
        });
    };
}
